import { ErrorMessage, Field, Form, Formik, FormikActions, FormikProps } from 'formik'
import React, { useState } from 'react'
import { Link, RouteComponentProps } from 'react-router-dom'
import * as Yup from 'yup'

import { Path } from 'adminConsole'
import { authStore } from 'adminConsole/store'
import { OtpVerifyModal } from 'mobileApp/system/component/OtpVerifyModal'
import { CodeMapTokenWithLocate } from '.'

interface AuthRequest {
  account: string
  password: string
  isPersistAccount?: any
}

export const Login: React.FC<RouteComponentProps> = props => {
  if (authStore.isLogin && authStore.isPass2FA) props.history.push('/')
  const account = authStore.userAccount
  const [isVerifying, setIsVerifying] = useState(false)

  return (
    <div className="container">
      <div className="row vh-100 align-items-center justify-content-center align-content-center">
        <section className="col-10 col-md-8">
          <section className="">
            <h2 className="font-weight-bold text-center">安盛保代</h2>
            <h3 className="text-secondary text-center mt-3">行動投保管理後台</h3>
          </section>

          <section className="mt-5 d-flex justify-content-center">
            <Formik
              initialValues={{ account, password: '', isPersistAccount: false }}
              validationSchema={Yup.object().shape({
                account: Yup.string().trim().email('請輸入 Email！').required('必填欄位！'),
                password: Yup.string().required('必填欄位！'),
              })}
              onSubmit={(
                { account, password, isPersistAccount }: AuthRequest,
                { setStatus, setSubmitting }: FormikActions<AuthRequest>
              ) => {
                setStatus()
                authStore
                  .login(account, password, isPersistAccount)
                  .then(() => setIsVerifying(true))
                  .catch(({ message }) => {
                    setStatus(message)
                    setSubmitting(false)
                  })
              }}>
              {formikProps => <LoginForm {...formikProps} isVerifying={isVerifying} setIsVerifying={setIsVerifying} />}
            </Formik>
          </section>
        </section>
      </div>
    </div>
  )
}

interface LoginFormProps extends FormikProps<AuthRequest> {
  isVerifying: boolean
  setIsVerifying: React.Dispatch<React.SetStateAction<boolean>>
}

const LoginForm = ({
  isVerifying,
  setIsVerifying,
  errors,
  status,
  touched,
  isSubmitting,
  setSubmitting,
}: LoginFormProps) => {
  return (
    <>
      <Form style={{ width: '360px' }}>
        <div className="form-group">
          <label htmlFor="account">帳號</label>
          <Field
            name="account"
            type="text"
            placeholder="請輸入登入 Email"
            className={'form-control' + (errors.account && touched.account ? ' is-invalid' : '')}
          />
          <ErrorMessage name="account" component="div" className="invalid-feedback" />
        </div>

        <div className="form-group">
          <label htmlFor="password">密碼</label>
          <Field
            name="password"
            type="password"
            className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')}
          />
          <ErrorMessage name="password" component="div" className="invalid-feedback" />
        </div>

        <div className="form-group">
          <div className="custom-control custom-checkbox">
            <Field type="checkbox" name="isPersistAccount" id="isPersistAccount" className={'custom-control-input'} />
            <label htmlFor="isPersistAccount" className="custom-control-label">
              記住登入帳號
            </label>
          </div>
        </div>

        {status && <div className="text-danger">{status}</div>}

        <button type="submit" className="btn btn-secondary w-100 mt-4" disabled={isSubmitting}>
          登入
        </button>
        <Link to={Path.PasswordReset} className="password_reset mt-4">
          忘記密碼？
        </Link>
      </Form>
      <OtpVerifyModal
        isOpen={isVerifying}
        setIsVerifying={setIsVerifying}
        setSubmitting={setSubmitting}
        locateAt={CodeMapTokenWithLocate.Admin}
      />
    </>
  )
}
